import React, { memo } from "react";
import { observer, inject } from "mobx-react";
import { withTheme } from "@material-ui/core/styles";
import { DISPATCH_MAP_FILTERS } from "../constants";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import { Marker, Popup } from "../../../../../lib/Map";
import SpottedTrailerMarker from "../../../../mapComponents/Markers/Dispatch/SpottedTrailerMarker";
import { SpottedTrailerPopupInfo } from "../../../../mapComponents/Popups";
import { withSnackbar } from "notistack";
import Events from "../../../../../utilities/EventEmitter";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../appConfigContext";
import appConstants from "../../../../../appConstants";

@inject("DispatchStore")
@observer
class SpottedTrailers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOptionSelected: this.isSpottedTrailerSelected(),
      spottedTrailerList: [],
      selectedTrailer: null,
    };
    this.isTrailerIconClicked = false;
    this.isHoverTrailerIcon =false;
  }

  componentDidMount() {
    this.props.glEventHub.on(
      this.props.headerId + "_multiSelectSelected",
      this.handleCheckBoxSelection
    );
    Events.on("RemoveMapPopup", this.hideTrailerPopup);
    this.props.glEventHub.on(
      "UpdateSpottedTrailers",
      this.updateSpottedTrailer
    );
    Events.on("UpdateSpottedTrailers", this.updateSpottedTrailer);
    this.updateSpottedTrailer();
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      this.props.headerId + "_multiSelectSelected",
      this.handleCheckBoxSelection
    );
    Events.off("RemoveMapPopup", this.hideTrailerPopup);
    this.props.glEventHub.off(
      "UpdateSpottedTrailers",
      this.updateSpottedTrailer
    );
    Events.off("UpdateSpottedTrailers", this.updateSpottedTrailer);
  }

  isSpottedTrailerSelected = () => {
    return this.props.DispatchStore.stopsFilter.includes(
      DISPATCH_MAP_FILTERS.spottedTrailers
    );
  };

  updateSpottedTrailer = (terminalCode = this.props.terminalCode) => {
    if (!this.state.isOptionSelected) {
      return;
    }
    getDataWithQueryString(
      "SpottedTrailer",
      `terminalCode=${terminalCode}`
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          spottedTrailerList: response.data,
        });
      } else {
        this.setState({
          spottedTrailerList: [],
        });
        this.props.enqueueSnackbar(
          `Error while fetching dropped trailers data`,
          {
            variant: "error",
          }
        );
      }
    });
  };

  handleCheckBoxSelection = (options) => {
    const isOptionSelected = options
      .map((option) => option.value)
      .includes(DISPATCH_MAP_FILTERS.spottedTrailers);
    if (this.state.isOptionSelected !== isOptionSelected) {
      this.setState(
        {
          isOptionSelected,
          ...(!isOptionSelected && { selectedTrailer: null }),
        },
        () => {
          if (this.state.spottedTrailerList.length === 0) {
            this.updateSpottedTrailer();
          }
        }
      );
    }
  };

  hideTrailerPopup = () => {
    if (this.state.selectedTrailer) {
      this.isTrailerIconClicked = false;
      this.setState({
        selectedTrailer: null,
      });
    }
  };

  onTrailerIconClick = (selectedTrailer) => {
    this.isTrailerIconClicked = true;
    this.setState({
      selectedTrailer,
    });
  };

  onTrailerIconHover = (selectedTrailer) => {
    if (!this.isTrailerIconClicked){     
      this.isTrailerIconClicked = false;
      this.isHoverTrailerIcon = true;
      this.setState({
        selectedTrailer,
      });
      this.props.onHoverOutOnMap();
      this.props.onMouseLeftStopMarker();
   }
  };

  onMouseLeftTrailerIcon=()=>{
    if(!this.isTrailerIconClicked && this.isHoverTrailerIcon){
      this.isHoverTrailerIcon = false;
      this.setState({
        selectedTrailer: null,
      });
    }
  }

  render() {
    const { headerId, glEventHub, terminalCode, theme, ...mapProps } = this.props;
    const { isOptionSelected, spottedTrailerList, selectedTrailer } =
      this.state;
    const showOnHoverPopup = this.props.DispatchStore.showOnHoverPopup;
    if (!isOptionSelected) {
      return null;
    }
    return (
      <>
        {spottedTrailerList.map((trailer) => {
          const isTrailerSelected = !this.isHoverTrailerIcon &&
            selectedTrailer?.data?.trailerId === trailer.trailerId;
          return (
            <Marker
              {...mapProps}
              position={{
                lat: trailer.latitude,
                lng: trailer.longitude,
              }}
              zIndex={isTrailerSelected ? 3 : 2}
              key={trailer.trailerId}
              data={trailer}
              onClick={this.onTrailerIconClick}
              onMouseHover={this.onTrailerIconHover}
              thresholdZoomLevel={appConstants.STOP_POPUP_THRESHOLD_ZOOM_LEVEL}
              onMouseOut={this.onMouseLeftTrailerIcon}
              showOnHoverPopup={showOnHoverPopup && !this.isTrailerIconClicked}
            >
              <SpottedTrailerMarker
                backgroundColor={isTrailerSelected ? theme.white : theme.unassignPickupFillColor}
                borderColor={isTrailerSelected ? theme.unassignPickupFillColor : theme.markerStokeColor}
              />
            </Marker>
          );
        })}
        {selectedTrailer && (
          <Popup
            {...mapProps}
            marker={selectedTrailer.marker}
            position={selectedTrailer.position}
          >
            <SpottedTrailerPopupInfo
              trailerData={selectedTrailer.data}
              showTrailerScac={this.props.configJSON.showTrailerScac}
            />
          </Popup>
        )}
      </>
    );
  }
}

export default compose(withSnackbar, withTheme(), withAppConfig)(memo(SpottedTrailers));
